export interface ProgressColorMap {
  boundary: number | null;
  color: string;
}

export enum ProgressDisplayFormat {
  Percentage = 'percentage',
  Absolute = 'absolute',
}

export enum ProgressDisplayType {
  Bar,
  Text,
}
